export function stripInepCodeDigits(value: string, maxLength = 8): string {
  return value.replace(/\D/g, '').slice(0, maxLength);
}
